import React, { useState, useEffect } from "react";
import "./CSS/Contact.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Loader from "./Components/Loader";
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';


const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  };
  
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

const Contact = () => {

   useEffect(()=>{
                  document.title="Contact | Balaji Badminton Academy"
                },[]);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [latestId, setLatestId] = useState(0);
    const [feedbackMessage, setFeedbackMessage] = useState(""); 

    
  useEffect(() => {
    const fetchLatestId = async () => {
      try {
        const snapshot = await firebase.database()
          .ref("Contact Form")
          .orderByChild("Contact_id")
          .limitToLast(1)
          .once("value");
        if (snapshot.exists()) {
          const latestEntry = snapshot.val();
          const latestIdValue = Object.values(latestEntry)[0].Contact_id;
          setLatestId(latestIdValue);
        } else {
          setLatestId(0);
        }
      } catch (error) {
        console.error("Error fetching latest ID:", error);
      }
    };

    fetchLatestId();
  }, []);


  
  const handleSubmit = async (event) => {
    event.preventDefault();

    const db = firebase.database();

    try {
      console.log("Latest ID:", latestId);
      const newId = latestId + 1;
      console.log("New ID:", newId);
      // Push form data to the database
      await db.ref("Contact Form").push({
        Contact_id: newId,
        Contact_name: name,
        Contact_email: email,
        Contact_message: message,
      });

      // Clear form fields and set success message
      setName("");
      setEmail("");
      setMessage("");
    //   toast.success(`Message sent successfully`);
      setFeedbackMessage("Message sent successfully!"); 
    } catch (error) {
      console.error("Error storing form data:", error);
      setFeedbackMessage("Failed to send message. Please try again."); 
    //   toast.error(`Failed to send message. Please try again.`);
    }
  };

    return (
        <>
            <Header />
            <Loader/>
            <div className="Contact_section">
                <div className="Contact_container">
                    <div className="front side">
                        <h1 className="text-center">Contact Me</h1>
                        <div className="row">
                            <div className="maplocation">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d486.24196582092543!2d80.22358246015548!3d12.847427848632249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1729495221105!5m2!1sen!2sin"
                                   
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                            <div className="Contact_content1">
                            <form onSubmit={handleSubmit}>
                                <label>Your Name :</label>
                                <input type="text" value={name} onChange={(event)=> setName(event.target.value)} required />
                                <label>Your E-mail :</label>
                                <input type="text" value={email} onChange={(event)=> setEmail(event.target.value)} required/>
                                <label>Your message :</label>
                                <textarea defaultValue={""} value={message}  onChange={(event) => setMessage(event.target.value)} required/>
                                <input type="submit" className="buttoncolor btn" defaultValue="Send Message" />
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Contact;
